$(function () {
    "use strict";

    // supply
    function orientationDetect() {
        if ( $(window).height() < $(document).width() ) {
            $('body').removeClass('isPortrait').addClass('isLandscape');

            if ($('.fight').length) {
                // $('#pleaserotate-backdrop').show();
            }
        } else {
            $('body').removeClass('isLandscape').addClass('isPortrait');

            if ($('.fight').length) {
                $('#pleaserotate-backdrop').hide();
            }
        }
    }
    $(window).resize(_.debounce(orientationDetect, 500));
    orientationDetect();






    /**
     * валидация форм
     */
    var validation = {
        init: function () {
            $.extend(jQuery.validator.messages, {
                required: 'это обязательное поле',
                email: 'введи верный e-mail',
            });
            $.validator.addMethod(
                "regex",
                function(value, element, regexp)  {
                    if (regexp.constructor != RegExp) regexp = new RegExp(regexp);
                    else if (regexp.global) regexp.lastIndex = 0;
                    return this.optional(element) || regexp.test(value);
                }
            );

            var isSubmitted = false;
            $('.js-validate').validate({
                rules: {
                    email: {
                        required: true,
                        email: true,
                        regex: /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b/i
                    }
                },
                // submitHandler: function(form) {
                //     if (!isSubmitted) {
                //         isSubmitted = true;
                //         $(form).submit();
                //     }
                // }
            });

            $('.email-form').on('change keyup', 'input.field', function () {
                if(validation.authIsEmpty()) {
                    validation.changeAuthBtn('red');
                } else {
                    validation.changeAuthBtn('green');
                }
            })
        },
        authIsEmpty: function () {
            var status = false;
            $('.email-form').find('input.field').each(function () {
                if (!$(this).val().length)
                    status = true;
            });
            return status;
        },
        changeAuthBtn: function (color) {
            if (color == 'red') {
                $('.email-form__join').removeClass('isGreen');
            } else {
                $('.email-form__join').addClass('isGreen');
            }
        }
    }

    if($('.js-validate').length) {
        validation.init();
    }

    /**
     * кнопка закрыть форму
     */
    $('.email-form__close').hover(function () {
        $(this).closest('.auth-first').addClass('isRotate');
    }, function () {
        $(this).closest('.auth-first').removeClass('isRotate');
    });

    var authForms = {
        init: function () {

            /**
             * закрыть формы входа по почте
             */
            $('.email-form__close').click(function (e) {
                e.preventDefault ? e.preventDefault() : (e.returnValue = false);
                authForms.authOpen();
            });

            /**
             * клик по входу через почту
             */
            $('.auth-first__soc-item.isEmail').click(function (e) {
                e.preventDefault ? e.preventDefault() : (e.returnValue = false);
                authForms.emailOpen();
            });
        },
        emailOpen: function () {
            $('.auth-first.isEmail').removeClass('isInactive').addClass('isActive').attr('hidden', false);
            $('.auth-first:not(.isEmail)').removeClass('isActive').addClass('isInactive');

        },
        authOpen: function () {
            $('.auth-first.isEmail').addClass('isInactive').removeClass('isActive');
            $('.auth-first:not(.isEmail)').removeClass('isInactive').addClass('isActive');
        }
    }

    /**
     * чемпионы
     */

    // склонения
    var declOfNum = (function(){
        var cases = [2, 0, 1, 1, 1, 2];
        var declOfNumSubFunction = function(titles, number){
            number = Math.abs(number);
            return titles[ (number%100>4 && number%100<20)? 2 : cases[(number%10<5)?number%10:5] ];
        }
        return function(_titles) {
            if ( arguments.length === 1 ){
                return function(_number){
                    return declOfNumSubFunction(_titles, _number)
                }
            }else{
                return declOfNumSubFunction.apply(null,arguments)
            }
        }
    })()

    if ($('.champ').length) {
        var champ = {
            row: '',
            init: function () {
                // this.tableRender(); // TODO COMMENT

                $('.champ').closest('main').addClass('isChamp');
            },
            tableRender: function () {
                var item;

                this.row = $(document.createDocumentFragment());
                this.row.append($.parseHTML($('#table-row-tpl').html()));

                for(var i=0; i<champions.length; i++) {
                    item = window.champions[i];

                    var decl = declOfNum(['победа','победы','побед'], item[3]);


                    this.row.find('.champ__user-photo').css('background-image', 'url(' + item[0] + ')').end()
                        .find('.champ__name').text(item[1]).end()
                        .find('.champ__city').text(item[2]).end()
                        .find('.champ__count').html('<span>' + item[3] + '</span> ' + decl + '');

                    $('.champ__table').append(this.row.clone());
                }
            }
        }

        champ.init();
    }

    authForms.init();
    /**
     * Выбор персонажа
     */
    var isIE = document.body.style.msTouchAction !== undefined;

    var preview = $('.character-preview');
    var characters = {
        timeout: '',
        init: function () {
            $('body').addClass('isChange');

            if ( $('.characters__item > input:checked').length ) {
                $('.characters__item > input:checked').prop('checked', false).trigger('change')
            }

            $('.btn.isGo').click(function (e) {
                 if ( !$('.characters__item > input:checked').length ) {
                     e.preventDefault ? e.preventDefault() : (e.returnValue = false);

                     $('.characters').addClass('isPulse');
                     setTimeout(function () {
                         $('.characters').removeClass('isPulse');
                     },1000);
                 }
            });

            $('.characters__item input[type="radio"]').on('change', function () {
                if (isIE) {
                    var parentItem = $(this).closest('.characters__item')
                    parentItem.find('svg').addClass('ieIeHover');
                    setTimeout(function () {
                        parentItem.find('svg').removeClass('ieIeHover');
                    }, 1000)
                }

                characters.styleItem($(this).closest('.characters__item'));
            });

            $('.characters__item').hover(_.debounce(function () {
                if (!$('.characters__item.isActive').length)
                    characters.hoverIn($(this))
            }, 400), function () {
                if (!$('.characters__item.isActive').length)
                    characters.hoverOut($(this))
            });

            $.imgpreload(['/i/characters/1-big.png',
                '/i/characters/2-big.png',
                '/i/characters/3-big.png',
                '/i/characters/4-big.png',
                '/i/characters/5-big.png',
                '/i/characters/6-big.png',
                '/i/characters/arms-boys.png',
                '/i/characters/arms-girls.png',
            ]);
        },
        hoverIn: function (hovered, changed) {
            preview.children('.character-preview__img')
                .attr('src', hovered.data('hover-img'))
                .addClass('isActive firstHovered').removeClass('isInactive');
        },
        hoverOut: function (hovered) {
            preview.children('.character-preview__img')
                .removeClass('isActive').addClass('isInactive')
        },
        styleItem: function (changedItem, init) {
            var svgEl = changedItem.find('svg');

            if ( typeof characters.timeout == 'number' )
                clearTimeout(characters.timeout);

            if($('.characters__item.isActive').length) {
                var activeItem = $('.characters__item.isActive');
                characters.hoverOut(activeItem);

                activeItem.removeClass('isActive');

                if(activeItem.find('feOffset').length) {
                    activeItem.find('feOffset').attr('dy', '4').prev('feGaussianBlur')[0].setAttribute('stdDeviation', '12');
                }
            }
        
            changedItem.addClass('isActive');
            if (window.matchMedia("(max-width:1170px)").matches)
                setTimeout(() => {
                    $('html, body').animate({'scrollTop': $(".btn.isGo").offset().top}, 500);
                }, 300);

            characters.timeout = setTimeout(function () {
                characters.hoverIn(changedItem);
                sessionStorage.setItem('characterType', changedItem.data('type'));
                sessionStorage.setItem('characterImg', changedItem.data('hover-img'));
            }, 400);

            if(svgEl.find('feOffset').length) {
                svgEl.find('feOffset').attr('dy', '0').prev('feGaussianBlur')[0].setAttribute('stdDeviation', '0');
            }
        }
    }

    if ($('.characters-wrap').length) {
        characters.init();
    }

    $.fn.extend({
        fadeInCss: function () {
            var animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
            this.addClass('animated fadeIn isActive').one(animationEnd, function() {
                $(this).removeClass('animated fadeIn isActive');
            });
            return this;
        },
        fadeOutCss: function () {
            var animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
            this.addClass('animated fadeOut isActive').one(animationEnd, function() {
                $(this).removeClass('animated fadeOut isActive');
            });
            return this;
        }
    });

    // todo
    // setTimeout(function () {
    //     if (typeof preloader !== 'undefined') {
    //         preloader.isLoad()
    //         fight.progress(10)
    //     }
    //
    // }, 3000)

    if($('.fight').length) {
        window.fight = {
            statusEl: $('#game-status'),
            progressValue: 0,
            isStart: false,
            onResize: function () {
                if (window.matchMedia('(max-width: 1023px)')) {
                    $('.fight__arms-wrap').css('bottom',
                        ($(document).height() - $('.fight__hero.isLeft')[0].getBoundingClientRect().top - $('.fight__hero.isLeft')[0].getBoundingClientRect().height) + 'px'
                    );
                } else {
                    $('.fight__arms-wrap').css('bottom',
                        ($(window).height() - $('.fight__hero.isLeft')[0].getBoundingClientRect().top - $('.fight__hero.isLeft')[0].getBoundingClientRect().height) + 'px'
                    );
                }
            },
            init: function (gameType) {
                $('#start-countdown').addClass('isActive');

                setTimeout(function () {
                    $('.start-countdown-screen.is-4').addClass('isActive');
                }, 3000);

                // setTimeout(function () {
                    // $('#audioStart')[0].play();
                // }, 2000);
                fight.calculateStep(0);


                fight.onResize();

                $(window).resize(_.debounce(fight.onResize, 200));

                setTimeout(function () {
                    $('#start-countdown').removeClass('isActive');
                    fight.roundStart();
                    $(window).trigger('isStart');
                    fight.isStart = true;

                    /**
                     * space click
                     */
                    $(document).on('keydown.space', function (e) {
                        fight.spaceClick(e)
                    });

                    $(window).resize(_.debounce(function () {
                        fight.progress(fight.progressValue);
                    }, 600));

                }, 4000);

                /**
                 * тип игроков
                 * 0 - м - ж
                 * 1 - ж - м
                 * 2 - м - м
                 * 3 - ж - ж
                 */
                // typeof gameType == 'undefined' ? gameType = 0 : false;

                gameType = fight.parseSex();
                window.fight.gameType = gameType;
                switch (gameType) {
                    case 0:
                        $('#userPic').closest('.fight__hero').addClass('isMan')
                        $('#enemyPic').closest('.fight__hero').addClass('isWoman')
                        break;
                    case 1:
                        $('#fightArms').css('transform', 'translateX(-50%) rotateY(180deg)');
                        $('#userPic').closest('.fight__hero').addClass('isWoman')
                        $('#enemyPic').closest('.fight__hero').addClass('isMan')
                        break;
                    case 2:
                        $('#fightArms').attr('src', '/i/characters/arms-boys.png');
                        $('#userPic').closest('.fight__hero').addClass('isMan')
                        $('#enemyPic').closest('.fight__hero').addClass('isMan')
                        break;
                    case 3:
                        $('#fightArms').attr('src', '/i/characters/arms-girls.png');
                        $('#userPic').closest('.fight__hero').addClass('isWoman')
                        $('#enemyPic').closest('.fight__hero').addClass('isWoman')
                        break;
                }
            },
            emotionControl: function () {
                function getPos(img) {
                    // var srcNumber = img.attr('src');
                    var imgW = img[0].getBoundingClientRect().width;

                    if (window.matchMedia('(max-width: 400px) and (min-height: 790px)').matches) {
                        return imgW *= 2.5;
                    } else if (window.matchMedia('(max-width: 1024px) and (min-height: 540px)').matches) {
                        return imgW *= 1.7;
                    } else if (window.matchMedia('(max-width: 1024px)').matches) {
                        return imgW *= 1.5;
                    }

                    return imgW;
                }

                $('#userPic + .fight__emotion').css('left', getPos($('#userPic')) + 'px')
                $('#enemyPic + .fight__emotion').css('right', getPos($('#enemyPic')) + 'px')
            },
            parseSex: function () {
                var local = $('#userPic').attr('src'),
                    enemy = $('#enemyPic').attr('src'),
                    val = 0;

                local = local.match(/\d+/g);
                enemy = enemy.match(/\d+/g);

                if (local > 3 && enemy > 3)
                    return 3

                if (local > 3 && enemy < 4)
                    return 1

                if (local < 4 && enemy < 4)
                    return 2

                if (local < 4 && enemy > 4)
                    return 0
            },
            spaceClick: function (e) {
                var timer,
                    pushBtn = $('#pushBtn');

                if (e.keyCode == 32) {
                    clearTimeout(fight.spaceClick);
                    pushBtn.removeClass('isClicked').addClass('isClicked');
                    fight.spaceClick.timer = setTimeout(function () {
                        pushBtn.removeClass('isClicked')
                    }, 100);
                }
            },
            roundStart: function () {
                /**
                 * таймер
                 */
                var timerEl = $('.fight__timer'),
                    duration = 25;

                timerEl.addClass('timerActive')
                timerEl.timer({
                    duration: duration,
                    format: '%M:%S',
                    countdown: true,
                    callback: function () {
                        clearTimeout(timer);
                        timerEl.removeClass('timerActive')
                        timerEl.timer('remove');
                    }
                });

                /**
                 * 3 секунды до конца
                 */
                var timer = setTimeout(function () {
                    timerEl.addClass('isRed');
                }, (duration - 3) * 1000);
            },
            gameFinal: function(status) {
                this.statusEl.addClass('isActive');

                if ($('.fight__timer.timerActive').length) {
                    $('.fight__timer.timerActive').removeClass('timerActive').timer('remove');
                }

                if (status == true) {
                    this.statusEl.find('.status__share').css('pointer-events', 'none');
                    this.statusEl.find('.status').removeClass('isLose').addClass('isWinner');

                    setTimeout(function () {
                        fight.statusEl.find('.status__share').addClass('isActive');
                    }, 100);

                    setTimeout(function () {
                        fight.statusEl.find('.status__share').css('pointer-events', 'auto');
                    },500);
                } else {
                    this.statusEl.find('.status').removeClass('isWinner').addClass('isLose');
                }
                $(document).off('keydown.space');
            },
            refreshEmotion: function (progress) {
                $('.fight__hero.isEmotion').removeClass('isEmotion');
                if(progress > 6) {
                    this.emotionControl();
                    $('.fight__hero.isLeft').addClass('isEmotion');
                } else if(progress < -6) {
                    this.emotionControl();
                    $('.fight__hero.isRight').addClass('isEmotion');
                }
            },
            calculateStep: function (progress) {
                var ratio = 60;
                var dW = $(document).width();

                var aspectRatio = dW / $(document).height();

                if (dW > 1300 && aspectRatio > 1.3) {
                    // if ( aspectRatio >= 1.1 && aspectRatio < 1.2 )
                    //     ratio = 200
                    //
                    // if ( aspectRatio >= 1.2 && aspectRatio < 1.3 )
                    //     ratio = 200
                    $('body').removeClass('ar-1 ar-09')

                    if ( aspectRatio >= 1.3 && aspectRatio < 1.4 )
                        ratio = 160

                    if ( aspectRatio >= 1.4 && aspectRatio < 1.5 )
                        ratio = 130

                    if ( aspectRatio >= 1.5 && aspectRatio < 1.6 )
                        ratio = 88

                    if ( aspectRatio >= 1.6 && aspectRatio < 1.7 )
                        ratio = 75

                    if ( aspectRatio >= 1.7 && aspectRatio < 1.8 )
                        ratio = 61

                    if ( aspectRatio >= 1.8 && aspectRatio < 1.9 )
                        ratio = 55

                    if ( aspectRatio >= 1.9 && aspectRatio < 2 )
                        ratio = 50

                    if ( aspectRatio >= 2 && aspectRatio < 2.1 )
                        ratio = 47

                    if ( aspectRatio >= 2.1 && aspectRatio < 2.2 )
                        ratio = 45

                    if ( aspectRatio >= 2.2 && aspectRatio < 2.3 )
                        ratio = 43.5

                    if ( aspectRatio >= 2.3 && aspectRatio < 2.4 )
                        ratio = 42

                    if ( aspectRatio >= 2.4 && aspectRatio < 2.5 )
                        ratio = 40

                    if ( aspectRatio >= 2.5 && aspectRatio < 2.6 )
                        ratio = 39

                } else {
                    if (aspectRatio <= 1.3) {
                        $('body').addClass('ar-1').removeClass('ar-09')
                    }

                    if (aspectRatio < 1) {
                        $('body').addClass('ar-09')
                        if ( aspectRatio >= 0.4 && aspectRatio < 0.5 )
                            ratio = 90

                        if ( aspectRatio >= 0.5 && aspectRatio < 0.6 )
                            ratio = 120

                        if ( aspectRatio >= 0.6 && aspectRatio < 0.7 )
                            ratio = 100

                        if ( aspectRatio >= 0.7 && aspectRatio < 0.8 )
                            ratio = 50

                        if ( aspectRatio >= 0.8 && aspectRatio < 0.89 )
                            ratio = 120

                        if ( aspectRatio >= 0.89 && aspectRatio < 0.95 )
                            ratio = 90

                        if ( aspectRatio >= 0.95 && aspectRatio <= 1 )
                            ratio = 50
                    }


                    if ( aspectRatio > 1.0 && aspectRatio < 1.1 )
                        ratio = 150

                    if ( aspectRatio >= 1.1 && aspectRatio < 1.2 )
                        ratio = 100

                    if ( aspectRatio >= 1.2 && aspectRatio < 1.3 )
                        ratio = 75

                    if ( aspectRatio >= 1.3 && aspectRatio < 1.4 )
                        ratio = 60

                    if ( aspectRatio >= 1.4 && aspectRatio < 1.5 )
                        ratio = 55

                    if ( aspectRatio >= 1.5 && aspectRatio < 1.6 )
                        ratio = 50
                }
                console.log(aspectRatio)

                return ( (-1 * $('#fightArms').width() / 2)) + (dW / ratio) * progress; // return position
            },
            progress: function (progress) {
                if ( typeof progress !== 'undefined' ) {
                    fight.progressValue = progress;
                } else {
                    progress = 0
                }

                var translate = fight.calculateStep(progress);


                this.refreshEmotion(progress);

                if(window.fight.gameType !== 1) {
                    if(progress >= 0) {
                        $('#fightArms').css('transform', 'translateX(' + translate + 'px)');
                        // $('#fightArms').css('transform', 'translateX(calc(-50% + ' + translate + 'px))');

                    } else {
                        $('#fightArms').css('transform', 'translateX(' + translate + 'px)');
                        // $('#fightArms').css('transform', 'translateX(calc(-50% + ' + translate + 'px))');
                    }
                } else {
                    $('#fightArms').css({
                        transform: 'translateX(' + translate + 'px) rotateY(180deg)'
                    });
                }
            }
        }

        var fightAdaptive = {
            isMobile: false,
            hero: {
                left: {
                    el: $('.fight__hero.isLeft'),
                    name: $('.fight__hero.isLeft .fight__name')
                },
                right: {
                    el: $('.fight__hero.isRight'),
                    name: $('.fight__hero.isRight .fight__name')
                }
            },
            init: function () {
                fightAdaptive.onResize();
                $(window).resize(_.debounce(fightAdaptive.onResize, 500));
            },
            onResize: function () {
                if (window.matchMedia('(max-width: 1025px), (max-width: 1025px) and (min-height: 1300px)').matches) {
                    if (!fightAdaptive.isMobile) {
                        $('main').prepend(fightAdaptive.hero.left.name).prepend(fightAdaptive.hero.right.name);
                    }
                } else if (fightAdaptive.isMobile) {
                    fightAdaptive.hero.left.el.append(fightAdaptive.hero.left.name);
                    fightAdaptive.hero.right.el.append(fightAdaptive.hero.right.name);
                }
            }
        }

        fightAdaptive.init();
    } else {

    }

    var about = {
        init: function () {
            function pad(d) {
                return (d < 10) ? '0' + d.toString() : d.toString();
            }

            $('.about').on('click', '.slick-slide', function (e) {
                var imgW = e.target.getBoundingClientRect().width,
                    sliderInstance = $(this).closest('.slick-slider');
                if (e.offsetX > (imgW / 2)) {
                    sliderInstance.slick('slickNext');
                } else {
                    sliderInstance.slick('slickPrev');
                }

            })

            $('#we-slider-counter').children('.all').text('/' + pad($('.we-slider__slide').length));

            $('#we-slick-slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                $('#we-slider-counter').children('.current').text(pad(nextSlide + 1));
            }).slick({
                arrows: false,
                dots: true,
                infinite: false,
                fade: true,
            });

            /**
             * слайдер продуктовый
             */
            about.getProductInfo(0);
            $('#product-slick-slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                about.getProductInfo(nextSlide);
            }).slick({
                arrows: false,
                dots: true,
                infinite: false,
                fade: true,
            });

            /**
             * клик по кнопке play
             */
            $('#YTPlayBtn').click(function (e) {
                e.preventDefault ? e.preventDefault() : (e.returnValue = false);
                var src = $('#video').data('iframe-src');
                $('#video').append('<iframe src="'+ src +'" frameborder="0" autoplay="1" allowfullscreen style="display:block;"></iframe>')

                setTimeout(function () {
                    $('#video iframe').addClass('isActive');
                }, 300)
            });
        },
        getProductInfo: function (number) {
            var docFragment = $(document.createDocumentFragment());
            docFragment.append($.parseHTML($('#product-text-tpl').html()));

            /**
             * рейтинг продукта
             */
            for(var i=0; i<productsInfo[number].rating; i++) {
                docFragment.find('.mini-product__rating').append('<i></i>');
            }

            /**
             * название
             */
            docFragment.find('.mini-product__title').text(productsInfo[number]['title'])

            /**
             * параметры
             */
            for(var i=0; i<productsInfo[number].table.length; i++) {
                docFragment.find('.mini-product__table').append('<div class="mini-product__row '+productsInfo[number].table[i][0]+'">' +
                    '<div class="mini-product__col">' + productsInfo[number].table[i][1] + '</div>' +
                    '<div class="mini-product__col">' + productsInfo[number].table[i][2] + '</div>' +
                    '</div>');
                
            }
            

            $('.mini-product__text-block.isActive').removeClass('isActive');
            setTimeout(function () {
                $('.mini-product .mini-product__text-block').remove();
                $('.mini-product').prepend(docFragment);
                $('.mini-product .mini-product__text-block').addClass('isActive');
            }, 300);

        }
    }

    if ($(".menu").length) {
        var menu = {
            btn: $("#js-mobile-menu-btn"),
            mobileContainer: $('#js-mobile-menu'),
            isActive: false,
            isRender: false,
            logo: {
                el: $('#js-logo'),
                desktopSrc: $('#js-logo > img').attr('src'),
                mobileSrc: $('#js-logo > img').attr('data-mobile-src'),
            },
            init: function () {
                menu.btn.click(function (e) {
                    e.preventDefault();
                    if (menu.isActive) {
                        menu.deactivate();
                    } else {
                        menu.activate();
                    }
                });

                $(window).resize(_.debounce(menu.onResize, 500));
                menu.onResize();
            },
            activate: function () {
                $('body').css('overflow', 'hidden');
                $('html, body').animate({'scrollTop': 0}, 200);
                menu.btn.addClass('isActive');
                menu.mobileContainer.addClass('isActive');
                menu.isActive = true;
            },
            deactivate: function () {
                $('body').css('overflow', '');
                menu.btn.removeClass('isActive');
                menu.mobileContainer.removeClass('isActive');
                menu.isActive = false;
            },
            onResize: function () {
                if (window.matchMedia('(max-width: 1023px), (max-width: 1025px) and (min-height: 1300px)').matches) {
                    if (!menu.isRender) {
                        menu.mobileContainer.append($('#js-header-menu')).append($('#js-copyright')).append($('#js-header-soc-block'));
                        menu.logo.el.children('img').attr('src', menu.logo.mobileSrc);
                        menu.isRender = true;
                    }
                } else if (menu.isRender) {
                    $('#js-header-menu').insertAfter('#js-logo');
                    $('#js-header-soc-block').insertAfter('#js-logo');
                    $('#js-copyright').insertAfter('main');
                    menu.logo.el.children('img').attr('src', menu.logo.desktopSrc);
                    menu.isRender = false;
                }
            }
        }
        menu.init();
    }

    if ($('.static-characters').length) {
        var staticChars = {
            left: {
                img: $('.static-characters__left > img'),
                src: {
                    desktop: $('.static-characters__left > img').attr('src'),
                    mobile: $('.static-characters__left > img').attr('data-mobile-src'),
                },
            },
            right: {
                img: $('.static-characters__right > img'),
                src: {
                    desktop: $('.static-characters__right > img').attr('src'),
                    mobile: $('.static-characters__right > img').attr('data-mobile-src'),
                },
            },
            isMobile: false,
            init: function () {
                staticChars.onResize();

                $(window).resize(_.debounce(staticChars.onResize, 400));
            },
            onResize: function () {
                if (window.matchMedia('(max-width: 1025px), (max-width: 1025px) and (min-height: 1300px)').matches) {
                    if (!staticChars.isMobile) {
                        staticChars.left.img.attr('src', staticChars.left.src.mobile);
                        staticChars.right.img.attr('src', staticChars.right.src.mobile);
                        staticChars.isMobile = true;
                    }
                } else if (staticChars.isMobile) {
                    staticChars.left.img.attr('src', staticChars.left.src.desktop);
                    staticChars.right.img.attr('src', staticChars.right.src.desktop);
                    staticChars.isMobile = false;
                }
            }
        }

        staticChars.init();
    }


    if ($('.about').length) {
        about.init();
    }
});


// WEBPACK FOOTER //
// ./js/script.js